import React, { useState, useCallback, useEffect } from 'react'
import LeftBar from './LeftBar'
import MainContent from './MainContent'
import RightBar from './RightBar'
import { Search, Bell, Comments, Settings, Plus } from '../../../components/icons/Icons'
import { Col, Row } from 'react-bootstrap'

import OriginalNotification from "../OriginalNotification"
import { useNavigate } from 'react-router-dom'

import { recentDraftListPath } from '../../../services/config'
import { ancemntNotification, initNotification } from '../../../redux/slices/announcementSlice'
import { useSelect } from '../../../services/commonServices'
import { useDispatch } from 'react-redux'

const Index = () => {
  const userData = JSON.parse(localStorage.getItem("user_data")) || {}

  const navigate = useNavigate()

  const dispatch = useDispatch()
  const socialHubStore = useSelect("announce")

  const [activeTab, setActiveTab] = useState("");
  const [collapsed, setCollapsed] = useState(false)   // ✅ lift collapse state here
  const [socialData, setSocialData] = useState([]);
  const [trendingTags, setTrendingTags] = useState([]);
  const [mostEngaged, setMostEngaged] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [yourActivity, setYourActivity] = useState([]);
  const [connectWith, setConnectWith] = useState([])
  const [serachHubs, setSerachHubs] = useState('')

  const getTemplateList = useCallback(() => {
    const formData = {
      path: recentDraftListPath,
      data: {
        "userId": userData.user_id,
        "isDraft": "2"
      }
    }
    dispatch(ancemntNotification(formData))
  }, [])

  useEffect(() => { getTemplateList() }, [])

  useEffect(() => {
    if (socialHubStore?.ancemntNotificationSuccess) {
      setSocialData(socialHubStore.ancemntNotificationData || [])
      dispatch(initNotification())
    }
  }, [socialHubStore])

const handleActiveTab = (item) => {
  setActiveTab(item)
  // ✅ Auto-collapse sidebar when switching to system request tabs
  const systemTabs = ["leave", "offsite", "regularisation", "halfDay"]
  if (systemTabs.includes(item)) {
    setCollapsed(true)
  } else {
    setCollapsed(false)
  }
}

  const navigateToAddAnnouncement = () => { navigate("/add-announcement") }

  const isSystemTab = activeTab === "leave" || activeTab === "offsite" || activeTab === "regularisation" || activeTab === "halfDay"

  return (
    <div
      className='section-sosial-hub'
      style={{ marginTop: isSystemTab ? "-20px" : "-40px" }}
    >
      {/* ── Header ─────────────────────────────────────────── */}
      <div className='social-hub-header'>
        <h3 className='hub-title color-white font-weight-200'>Employee Social Hub</h3>
        {!isSystemTab && (
          <>
            <div className='hub-search-container'>
              <input
                value={serachHubs}
                placeholder='Search posts, tags or people'
                className='universal-input'
              />
              <Search class_name={"search-icon"} />
            </div>
            <div className='notification-panel'>
              <span><Bell class_name='color-white icon' /></span>
              <span><Comments class_name='color-white icon' /></span>
              <span><Settings class_name='color-white icon' /></span>
              <button
                type="button"
                className="universal-btn border-radius-8px"
                onClick={navigateToAddAnnouncement}
              >
                <Plus /> Add Announcement
              </button>
            </div>
          </>
        )}
      </div>

      {/* ── Body — flex row so sidebar collapse auto-fills ── */}
      <div style={{ display: "flex", width: "100%", alignItems: "flex-start" }}>

        {/* Sidebar — controls its own width via collapsed state */}
        <LeftBar
          activeTab={activeTab}
          handleActiveTab={handleActiveTab}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        {/* Content area — grows to fill remaining space */}
        <div style={{
          flex: 1,
          minWidth: 0,           // prevents flex overflow
          transition: "all 0.3s ease",
          overflow: "hidden",
        }}>
          {isSystemTab ? (
  <div style={{ padding: "0 10px", width: "100%" }}>  {/* ✅ add width: "100%" */}
    <OriginalNotification active_tab={activeTab} />
  </div>
) : (
            <div style={{ display: "flex", gap: "10px", padding: "0 10px" }}>

              {/* Main feed — takes up flexible space */}
              <div style={{ flex: 1, minWidth: 0 }}>
                {Array.isArray(socialData) && socialData.length > 0 && (
                  <MainContent socialData={socialData} />
                )}
              </div>

              {/* Right bar — fixed width */}
              <div style={{ width: "260px", flexShrink: 0 }}>
                <RightBar
                  handleActiveTab={handleActiveTab}
                  trendingTags={trendingTags}
                  mostEngaged={mostEngaged}
                  upcomingEvents={upcomingEvents}
                  yourActivity={yourActivity}
                  connectWith={connectWith}
                />
              </div>

            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Index